"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeMarginNavNotification = exports.addMarginNavNotification = exports.REMOVE_MARGIN_NOTIFICATION_ICON = exports.ADD_MARGIN_NOTIFICATION_ICON = void 0;
var ADD_MARGIN_NOTIFICATION_ICON = exports.ADD_MARGIN_NOTIFICATION_ICON = 'ADD_MARGIN_NOTIFICATION_ICON';
var REMOVE_MARGIN_NOTIFICATION_ICON = exports.REMOVE_MARGIN_NOTIFICATION_ICON = 'REMOVE_MARGIN_NOTIFICATION_ICON';
var addMarginNavNotification = exports.addMarginNavNotification = function addMarginNavNotification() {
  return function (dispatch) {
    return dispatch({
      type: ADD_MARGIN_NOTIFICATION_ICON
    });
  };
};
var removeMarginNavNotification = exports.removeMarginNavNotification = function removeMarginNavNotification() {
  return function (dispatch) {
    return dispatch({
      type: REMOVE_MARGIN_NOTIFICATION_ICON
    });
  };
};